import { keepPreviousData, useQuery, type UseQueryResult } from '@tanstack/react-query';
import type { ListEnvelope } from '../../../shared/api/genexus-query';
import type { DataTableQuery } from '../../../shared/components/DataTable';
import { getExtratoFaturamentoTotais, listExtratoFaturamento } from './api';
import type {
  ExtratoFaturamentoFiltros,
  ExtratoFaturamentoItem,
  ExtratoFaturamentoTotais,
} from './types';

export function useExtratoFaturamento(
  query: DataTableQuery,
  filtros: ExtratoFaturamentoFiltros,
): UseQueryResult<ListEnvelope<ExtratoFaturamentoItem>> {
  return useQuery({
    queryKey: ['empresa-extrato-faturamento', 'list', query, filtros],
    queryFn: () => listExtratoFaturamento(query, filtros),
    placeholderData: keepPreviousData,
    staleTime: 30_000,
  });
}

/** Totais seguem os mesmos filtros + busca do List (conjunto inteiro). */
export function useExtratoFaturamentoTotais(
  filtros: ExtratoFaturamentoFiltros,
  busca?: string,
): UseQueryResult<ExtratoFaturamentoTotais> {
  return useQuery({
    queryKey: ['empresa-extrato-faturamento', 'totais', filtros, busca ?? ''],
    queryFn: () => getExtratoFaturamentoTotais(filtros, busca),
    placeholderData: keepPreviousData,
    staleTime: 30_000,
  });
}
